<mat-card appearance="outlined" class="mat-elevation-z4">
    <mat-card-header>
        <mat-card-title>
            {{ 'FactsAndFigures.Title' | translate }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <table class="table-check">
            <tr>
                <th></th>
                @for (item of items; track item.name) {
                    <th class="text-right" colspan="2">
                        {{ item.name }}
                        <br />
                        {{ 'FactsAndFigures.Number' | translate }}: {{ item.number }}
                        <br />
                        {{ 'FactsAndFigures.NominalValue' | translate }}:
                        {{ item.nominalValue | currency: 'CHF ' }}
                    </th>
                }
            </tr>
            <br />
            <tr>
                <td>
                    {{ 'FactsAndFigures.RegisteredShares' | translate }}
                </td>
                @for (item of items; track item.name) {
                    <td class="text-right">
                        {{ item.registeredShares | slNumber }}
                    </td>
                    <td class="text-right">{{ item.registeredSharesPercent | slNumber }}%</td>
                }
            </tr>
            <tr>
                <td>
                    {{ 'FactsAndFigures.DispoShares' | translate }}
                </td>
                @for (item of items; track item.name) {
                    <td class="text-right">
                        {{ item.dispoShares | slNumber }}
                    </td>
                    <td class="text-right">{{ item.dispoPercent | slNumber }}%</td>
                }
            </tr>
            <tr>
                <td>
                    {{ 'FactsAndFigures.NumberOfShares' | translate }}
                </td>
                @for (item of items; track item.name) {
                    <td class="text-right">
                        {{ item.numberOfShares | slNumber }}
                    </td>
                    <td class="text-right">100.00%</td>
                }
            </tr>
            @if (hasSubSection) {
                <br />
                <br />
                <tr>
                    <td>
                        {{ 'FactsAndFigures.ShareCapital' | translate }}
                    </td>
                    <td class="text-right">
                        {{ traderegisterNumberOfSharesSum | slNumber }}
                    </td>
                    <td class="text-right">CHF {{ traderegisterCapitalSum | slNumber: 2 }}</td>
                </tr>
                <tr>
                    <td>
                        {{ 'FactsAndFigures.ConditionalShareCapital' | translate }}
                    </td>
                    <td class="text-right">
                        {{ numberOfSharesSum - traderegisterNumberOfSharesSum | slNumber }}
                    </td>
                    <td class="text-right">CHF {{ conditionalCapitalSum | slNumber: 2 }}</td>
                </tr>
            }
            @if (hasSubSection && items.length > 1) {
                <tr>
                    <td>
                        {{ 'FactsAndFigures.TotalSharesIssued' | translate }}
                    </td>
                    <td class="text-right">
                        {{ numberOfSharesSum | slNumber }}
                    </td>
                    <td class="text-right">CHF {{ capitalSum | slNumber: 2 }}</td>
                </tr>
            }
            <br />
            <br />
            <tr>
                <td>
                    {{ 'FactsAndFigures.RegisteredShareholders' | translate }}
                </td>
                @if (items.length < 2) {
                    <td class="text-right">
                        {{ shareholdersCountSum | slNumber }}
                    </td>
                }
                <td class="text-right">
                    {{ registeredSharesSum | slNumber }}
                    {{ 'FactsAndFigures.Shares' | translate }}
                </td>
            </tr>
            <tr>
                <td>
                    {{ 'FactsAndFigures.WithVotingRights' | translate }}
                </td>
                @if (items.length < 2) {
                    <td class="text-right">
                        {{ shareholdersCountWithVotesSum | slNumber }}
                    </td>
                }
                <td class="text-right">
                    {{ votesSum | slNumber }}
                    {{ 'FactsAndFigures.Shares' | translate }}
                </td>
            </tr>
        </table>
    </mat-card-content>
</mat-card>
